import { render, staticRenderFns } from "./TableCreate.vue?vue&type=template&id=bafb4bda&"
import script from "./TableCreate.vue?vue&type=script&lang=js&"
export * from "./TableCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports